import * as Types from '@/types/schema';

import gql from 'graphql-tag';
import { EntityMediaFragmentDoc } from '../../../../../features/messages/graphql/fragments/generated/MediaType';
export type EventRecordingFragment = { id: string, duration: number, recordingMedia: { name: string, description?: string | null, url?: string | null, size?: number | null, mimeType?: string | null, mediaId: string, kind: Types.MediaKindEnum, resolutions?: Array<{ type: Types.ResolutionEnum, url: string }> | null } };


export type EventRecordingFragmentVariables = Types.Exact<{ [key: string]: never; }>;

export const EventRecordingFragmentDoc = /*#__PURE__*/ gql`
    fragment EventRecording on EventRecordingType {
  id
  duration
  recordingMedia {
    ...EntityMedia
  }
}
    `;